var module = angular.module('octopusApp.infrastructure');

module.filter('resolveLink', function (octopusClient) {

  return function (input, format) {
    if (!input || input === '') {
      return '';
    }
    return octopusClient.resolve(input);
  };

});





//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/resolve_link.js
// module id = 691
// module chunks = 1